


















import { defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';

export default defineComponent({
	components: { ConfirmDialog },
	props: {
		id: {
			required: true,
			type: String,
		},
		redirect: {
			required: false,
			default: false,
			type: Boolean,
		},
	},
	setup(props, { root }) {
		return {
			handleConfirmDelete: () => {
				root.$store.dispatch('samplingCollections/deleteSamplingCollection', props.id);
				if (props.redirect) {
					root.$router.push({ name: 'Sampling Collection List' });
				}
			},
			showConfirmationDialog: ref(false),
		};
	},
});
